export const Pattern = {
  Number: /^[0-9]+$/,
  FilterZeroFill: /^0+/,
  FilteringBracket: /\(([^)]+)\)/,
  SingleByteCharacterNumeric: /^[a-zA-Z0-9 \r\n\uff60-\uffef]*$/,
};

export default Pattern;
